var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('el-container',{staticStyle:{"height":"100%"}},[_c('el-header',{staticStyle:{"padding":"0px"},attrs:{"height":"70px"}},[_c('navbar')],1),_vm._v(" "),_c('el-container',[_c('el-aside',{attrs:{"width":"200px"}},[_c('menubar')],1),_vm._v(" "),_c('el-main',[_c('appmain')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a04bb544","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout.vue
// module id = null
// module chunks = 